import createSpinner from "../../../Functions/createSpinner";
import { customAutoCompleteFilter, customDatePickerFilter, standardGridPageSize } from "../../../GlobalVariables/filterVariables";

export default /*@ngInject*/ function (helperService, accessDetailsProfileDataService, connectionsDataService) {
    const vm = this;
    vm.helperService = helperService;

    vm.accessCollapsed = true;
    vm.businessProcessProductCollapsed = true;
    vm.customLogo = null;

    vm.$onInit = activate;

    async function activate() {
        await getBpGridData();
        await getProductLogo();
        setupGrid();
    }
    async function getProductLogo() {
        try {
            const { data } = await connectionsDataService.getProductLogo(vm.product.Type);
            vm.customLogo = data;
        } catch {
            vm.customLogo = null;
        }
    }

    function setupGrid() {
        let businessProcessProductProfileGridColumns;
        if (vm.accessDetailFields) {
            businessProcessProductProfileGridColumns = vm.accessDetailFields.map(field => {
                let column = {
                    field: field,
                    title: helperService.headerStringTransformer(field),
                    width: 120,
                    filterable: customAutoCompleteFilter
                }

                if (field === 'LastUsed') {
                    column.template = "{{ dataItem.LastUsed | date:'short' }}";
                    column.filterable = customDatePickerFilter;
                }

                return column;
            });
        } else {
            businessProcessProductProfileGridColumns = null;
        }

        vm.businessProcessProductProfileGridOptions = helperService.setMainGridOptions(businessProcessProductProfileGridColumns, 400);
        vm.businessProcessProductProfileGridOptions.autoBind = true;

        vm.businessProcessProductProfileGridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            schema: {
                model: {
                    fields: {
                        LastUsed: { type: "date" },
                        ViewCount: { type: "number" }
                    }
                }
            },
            noRecords: {
                template: "<div class='no-data-to-display-message'>No items to display</div>"
            },
            transport: {
                read: async options => {
                    try {
                        const data = await getBpGridData();
                        options.success(data);
                    } catch (err) {
                        return;
                    }
                }
            }
        });
    }

    async function getBpGridData() {
        vm.loading = new createSpinner();
        let postData = {
            "UserMasterId": vm.businessProcess.UserMasterId,
            "BusinessProcessId": vm.businessProcess.BusinessProcessId,
            "CompanyId": vm.businessProcess.CompanyId
        };

        try {
            vm.loading.loadingValue = true;
            let response;

            if (vm.businessProcess.SecurityObjectIdentifier) {
                postData.SecurityObjectIdentifier = vm.businessProcess.SecurityObjectIdentifier;
                postData.SecurityObjectTypeId = vm.businessProcess.SecurityObjectTypeId;
                response = await accessDetailsProfileDataService.getObjectLevelBusinessProcessDetails(vm.businessProcess, postData);
            } else {
                response = await accessDetailsProfileDataService.getBusinessProcessDetails(vm.businessProcess, postData);
            }

            vm.loading.loadingValue = false;

            let accessDetails = response.data.reduce((acc, curr) => {
                return acc.concat(curr.AccessDetails)
            }, []);

            vm.accessDetailFields = Object.keys(accessDetails[0]);

            return accessDetails;
        } catch {
            vm.loading.loadingValue = false;
        }
    }
}